export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1644_.d55d759b.jpg";